'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ContainerProps {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full' | string;
  component?: React.ElementType;
  className?: string;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  maxWidth = '2xl',
  component: Component = 'div',
  className = '',
}) => {
  // Map maxWidth to Tailwind classes
  const getMaxWidthClass = () => {
    const predefinedSizes = {
      xs: 'max-w-xs', // 320px
      sm: 'max-w-sm', // 384px
      md: 'max-w-md', // 448px
      lg: 'max-w-lg', // 512px
      xl: 'max-w-xl', // 576px
      '2xl': 'max-w-2xl', // 672px
      '3xl': 'max-w-3xl', // 768px
      '4xl': 'max-w-4xl', // 896px
      '5xl': 'max-w-5xl', // 1024px
      '6xl': 'max-w-6xl', // 1152px
      '7xl': 'max-w-7xl', // 1280px
      full: 'max-w-full',
    };

    return predefinedSizes[maxWidth as keyof typeof predefinedSizes] || `max-w-[${maxWidth}]`;
  };

  const containerClasses = twMerge(
    'container w-full mx-auto px-6 box-border',
    getMaxWidthClass(),
    className
  );

  return <Component className={containerClasses}>{children}</Component>;
};

export default Container;
